export default __webpack_public_path__ + "static/media/knowMore2.e496f39b.png";